<template>
	<form class="col" autocomplete="off">
		<input
			v-model="username"
			type="text"
			placeholder="Login"
			autocomplete="off"
		/>
		<input v-model="password" type="password" placeholder="Hasło" />
		<button class="button__save" @click.prevent="signIn" :disabled="isUpdating">
			<span v-if="!isUpdating">{{ $t('buttons.login') }}</span>
			<span v-else class="loader loader-small"></span>
		</button>
		<p v-if="error.length" class="error">{{ error }}</p>
	</form>
</template>
<script>
export default {
	data: () => ({
		username: '',
		password: '',
		error: '',
		isUpdating: false
	}),
	created() {
		if (this.$store.getters['auth/isSignIn']) {
			this.$router.push('/edit-movies')
		}
	},
	methods: {
		async signIn() {
			try {
				this.isUpdating = true
				this.error = ''
				await this.$store.dispatch('auth/signIn', {
					username: this.username,
					password: this.password
				})
				this.$router.push('/edit-movies')
			} catch (err) {
				this.error = this.$t('errors.wrong_credentials')
				this.isUpdating = false
			}
		}
	}
}
</script>
